
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/b19af0eade33e41a7188165c55b524a9/8cb2f97992f9a37e050cfb4e818e1234.png" 
              alt="Signature Cleaning Logo" 
              className="h-16 w-auto object-contain"
            />
            <span className="text-2xl font-bold text-gray-800" style={{ fontFamily: '"Pacifico", serif' }}>
              Signature Cleaning
            </span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/#services" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">
              Services
            </a>
            <a href="/#about" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">
              About
            </a>
            <a href="/#testimonials" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">
              Reviews
            </a>
            <a href="/sms-signup" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">
              SMS Updates
            </a>
            <a href="/#contact" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">
              Contact
            </a>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-gray-600">
              <i className="ri-phone-line text-orange-500"></i>
              <span className="text-sm">321-369-7930</span>
            </div>
            <Button onClick={() => scrollToSection('quote')} size="sm">
              Get Quote
            </Button>
          </div>

          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a href="/#services" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Services
              </a>
              <a href="/#about" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                About
              </a>
              <a href="/#testimonials" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Reviews
              </a>
              <a href="/sms-signup" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                SMS Updates
              </a>
              <a href="/#contact" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Contact
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
